module.exports = __webpack_public_path__ + "assets/img/btn-info-7c0a42d5.png";